import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  border-right: 1px solid #ccc;
  background-color: #e5ddd5;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #ccc;
  background-color: #fff;
`;
export const Info = styled.div`
  display: flex;
  width: 100%;
  min-height: 60px;
  align-items: center;
  padding: 0 1rem;
  gap: 1rem;
  .name {
    color: #000;
    font-size: 17px;
  }
  .phone {
    color: #999;
    font-size: 12px;
    margin-left: 10px;
  }
  .countdown {
    color: #999;
    font-size: 12px;
    margin-top: 0.2rem;
  }
`;
export const AreaMessage = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  background-color: #e5ddd5;
  overflow-y: auto;
  padding: 20px 30px;
  margin-bottom: 10px;
  #btn-loadMore {
    display: flex;
    width: 100%;
    height: 2.5rem;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    button {
      border: none;
      outline: none;
      width: 10rem;
      height: 2.5rem;
      color: rgb(73, 80, 87);
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      cursor: pointer;
      font-weight: bold;
      &:hover {
        box-shadow: 0 1px 1px #b5b5b5;
      }
    }
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(0, 0, 0, 0.2);
  }
`;
export const AreaInput = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 1rem;
  padding: 0px 1rem;
  .content--input {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    button {
      outline: none;
      border: none;
      width: 200px;
      height: 35px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: bolder;
      background: #1b72d6;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }
    }
    .load-span {
      display: flex;
      height: 35px;
      width: 50px;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background: #1b72d6;
    }
  }
  .scroll--bottom {
    position: absolute;
    display: flex;
    top: -6rem;
    right: -1px;
    width: 60px;
    height: 45px;
    justify-content: center;
    align-items: center;
    border-radius: 6px 0 0 6px;
    font-size: 1.75rem;
    cursor: pointer;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    color: #919191;
    background-color: #f8f9fa;
    animation: moverRight 0.9s forwards;
  }
  .notification-- {
    font-size: 1.5rem;
    color: #04d756;
  }
  @keyframes moverRight {
    from {
      right: -100px;
    }
    to {
      right: 0px;
    }
  }
`;
export const LoadMore = styled.div`
  display: flex;
  height: 4rem;
  width: 100%;
  margin-bottom: 4rem;
  justify-content: center;
  align-items: center;
  button {
    display: flex;
    width: 10rem;
    height: 2.5rem;
    color: #495057;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    border: none;
    font-weight: 700;
    justify-content: center;
    align-items: center;
    transition: filter 0.1s;
    transition: all 0.7s ease;
    cursor: pointer;
  }
`;
export const LoadMoreSpinerLoading = styled.div`
  border: 3px solid transparent;
  border-radius: 50%;
  border-top: 2.5px solid rgba(0, 0, 0, 0.4);
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const LoadCustomerServiceOpen = styled.div`
  border: 3px solid transparent;
  border-radius: 50%;
  border-top: 2.5px solid #ffffff;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;